import { render, staticRenderFns } from "./form-input.vue?vue&type=template&id=5a87fefe"
import script from "./form-input.vue?vue&type=script&lang=ts"
export * from "./form-input.vue?vue&type=script&lang=ts"
import style0 from "./form-input.vue?vue&type=style&index=0&id=5a87fefe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports